/* eslint-disable */
import allVendorServices from '@/Services/Form Services/allvendor.services';
import regionStateServices from '@/Services/regionState.services';
import productCategoryServcies from '@/Services/Form Services/productCategoryServcies';
import productSubCategoryServcies from '@/Services/Form Services/productSubCategoryServcies';

export const drillDownBuilders = {
	stores: {
		headers: [
			{ id: 'allRegion', label: 'All Region', color: '#eef1f5', textColor: '#475569' },
			{ id: 'region', label: 'Region', color: '#fdf6e3', textColor: '#b45309' },
			{ id: 'state', label: 'State', color: '#ecf5f0', textColor: '#0f766e' },
			{ id: 'city', label: 'City', color: '#fdf1ea', textColor: '#c2410c' },
			{ id: 'store', label: 'Store', color: '#eaf6f4', textColor: '#0d9488' },
		],
		fetchData: async () => {
			const response = await regionStateServices.getAllRegionMappings();
			return Array.isArray(response) ? response : [];
		},
		buildTree: (regionTree) => {
			// Row bg = same colors as the headers (levels in header order).
			const levelColors = [
				'#eef1f5',
				'#fdf6e3',
				'#ecf5f0',
				'#fdf1ea',
				'#eaf6f4',
			];
			const stampColors = (nodes, level = 0) => (nodes || []).map((node) => ({
				...node,
				color: levelColors[level] || '#f8fafc',
				children: stampColors(node?.children, level + 1),
			}));
			const tree = stampColors(regionTree);
			if (tree?.[0]) tree[0].select = -1;
			return tree;
		},
	},
	products: {
		headers: [
			{ id: 'skuType', label: 'SKU Type', color: '#eef1f5', textColor: '#475569' },
			{ id: 'category', label: 'Category', color: '#ecf5f0', textColor: '#16a34a' },
			{ id: 'subCategory', label: 'Sub Category', color: '#f1eefb', textColor: '#7c3aed' },
			{ id: 'product', label: 'Products', color: '#fdf6e3', textColor: '#d97706' },
			{ id: 'variant', label: 'Variant', color: '#fdeeee', textColor: '#dc2626' },
		],
		fetchData: async ({ productList }) => {
			const [categoryRes, subCategoryRes] = await Promise.all([
				productCategoryServcies.listProductCategory({ req: { params: { id: '' } } }),
				productSubCategoryServcies.listProductSubCategory({ req: { params: { id: '' } } }),
			]);
			return {
				categories: categoryRes?.data ?? [],
				subCategories: subCategoryRes?.data ?? [],
				products: productList ?? [],
			};
		},
		buildTree: ({ categories, subCategories, products }) => {
			// Row bg = same colors as the headers.
			const levelColors = {
				skuType: '#eef1f5',
				category: '#ecf5f0',
				subCategory: '#f1eefb',
				product: '#fdf6e3',
				variant: '#fdeeee',
			};
			const skuTypeOrder = ['PRODUCT', 'INTERMEDIATE', 'INGREDIENT', 'PACKAGING', 'OTHER', 'UNPACKED_PRODUCT'];
			const bySkuType = {};
			(products || []).forEach((product) => {
				const skuType = product?.skuType || 'OTHER';
				if (!bySkuType[skuType]) bySkuType[skuType] = [];
				bySkuType[skuType].push(product);
			});
			return Object.entries(bySkuType)
				.sort(([a], [b]) => {
					const rank = (key) => {
						const idx = skuTypeOrder.indexOf(key);
						return idx === -1 ? skuTypeOrder.length : idx;
					};
					return rank(a) - rank(b);
				})
				.map(([skuType, skuProducts]) => ({
					id: skuType,
					type: 'skuType',
					name: skuType,
					select: 0,
					color: levelColors.skuType,
					children: (categories || [])
						.map((category) => ({
							...category,
							id: category?.id,
							type: 'category',
							name: category?.productCategoryName,
							select: 0,
							color: levelColors.category,
							children: (subCategories || [])
								.filter((sub) => sub?.categoryId === category?.id)
								.map((subCategory) => ({
									...subCategory,
									id: subCategory?.id,
									type: 'subCategory',
									name: subCategory?.name,
									select: 0,
									color: levelColors.subCategory,
									children: skuProducts
										.filter((p) => p?.subCategoryId === subCategory?.id)
										.map((product) => ({
											...product,
											id: product?.id,
											type: 'product',
											name: product?.productName,
											select: 0,
											color: levelColors.product,
											children: (product?.variants || []).map(
												(variant) => ({
													...variant,
													id: `${product?.id}_${variant?.id}`,
													productId: product?.id,
													variantId: variant?.id,
													type: 'variant',
													name: variant?.displayName,
													unit: product?.unit,
													select: 0,
													color: levelColors.variant,
													children: [],
												})
											),
										}))
										.filter((p) => p.children.length > 0),
								}))
								.filter((sub) => sub.children.length > 0),
						}))
						.filter((cat) => cat.children.length > 0),
				}));
		},
	},
	buyers: {
		headers: [
			{ id: 'buyer', label: 'Buyer', color: '#fdf6e3', textColor: '#b45309' },
			{ id: 'location', label: 'Location', color: '#eaf6f4', textColor: '#0d9488' },
		],
		fetchData: async () => {
			const response = await allVendorServices.listVendor({ type: 'BUYER' });
			return response?.statusCode === 200 ? response?.data : [];
		},
		buildTree: (buyers) => (buyers || []).map((buyer) => ({
			id: buyer?.id,
			type: 'buyer',
			name: buyer?.name,
			select: 0,
			color: '#fdf6e3',
			children: (buyer?.vendor_locations || []).map((location) => ({
				id: location?.id,
				type: 'location',
				name: location?.name,
				select: 0,
				color: '#eaf6f4',
				children: [],
			})),
		})),
	},
};
export const collectSelectedByType = (nodes, acc = {}, parentSelected = false) => {
	(nodes || []).forEach((node) => {
		const isSelected = node?.select === 1
			|| (node?.select === 0 && parentSelected);
		if (isSelected) {
			if (!acc[node.type]) acc[node.type] = [];
			acc[node.type].push(node.id);
		}
		collectSelectedByType(
			node?.children,
			acc,
			isSelected && node?.select !== -1
		);
	});
	return acc;
};
